import moment from "moment";
import styled from "styled-components";
import React, { useState } from "react";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import { FlexContainer, Pill } from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import TableFields from "../../constants/DriverAppReleases/TableFields.json";
import { getPath } from "../../utils";
import Table from "../Common/Table";
import ActionBarAppReleasesList from "./ActionBarAppReleasesList";
import { downloadAppApks } from "../../store/actions/DriverAppReleases";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const AppReleasesList = ({
  list,
  downloadAppApks,
  permissions,
  allMenuActions,
}) => {
  const [showActionBar, setShowActionBar] = useState(false);
  const [activeReleaseId, setActiveReleaseId] = useState("");
  const [appReleaseVersion, setAppReleaseVersion] = useState(false);
  const [expandedText, setExpandedText] = useState("");
  const [activeAppRelease, setActiveAppRelease] = useState({});
  const [actionCoord, setActionCoord] = useState({
    top: "",
    right: "",
  });

  const handleActions = (action_id, active_id, version, activeRelease) => {
    setShowActionBar(true);
    setActiveReleaseId(active_id);
    setAppReleaseVersion(version);
    setActiveAppRelease(activeRelease);
    const activeAct = document.getElementById(`${action_id}`);
    // for (let i = 0; i < list.length; i++) {
    //   document.getElementById(`actions_${i}`).style.zIndex = 1;
    // }
    if (activeAct) {
      setActionCoord({
        top: activeAct.getBoundingClientRect().top + 10,
        right: window.innerWidth - activeAct.getBoundingClientRect().right,
      });
      activeAct.style.zIndex = 200;
    }
  };

  const handleBlur = () => {
    setShowActionBar(false);
  };

  const handleTextExpand = (action, index) => {
    setExpandedText(`${action}_${index}`);
  };

  const getFieldValue = (item, key, index) => {
    switch (key) {
      case "stable":
      case "show_on_driver_edit":
        return <Pill isFalse={!item[key]}>{item[key] ? "Yes" : "No"}</Pill>;
      case "created_at":
        return item[key]
          ? moment(item[key]).format("DD/MM/YYYY hh:mm A")
          : "NA";
      case "release_notes":
        return item[key].length > 150 ? (
          expandedText &&
          expandedText.split("_")[1] == index &&
          expandedText.split("_")[0] === "collapse" ? (
            <span>
              {item[key] + " ..."}
              <span
                className="expand-collapse-text"
                onClick={() => handleTextExpand("expand", index)}
              >
                collapse
              </span>
            </span>
          ) : (
            <span>
              {item[key].substr(0, 150) + "..."}
              <span
                className="expand-collapse-text"
                onClick={() => handleTextExpand("collapse", index)}
              >
                expand
              </span>
            </span>
          )
        ) : (
          item[key]
        );
      case "actions":
        return (
          <FlexContainer
            justify="flex-start"
            onClick={() => {
              handleActions(
                `actions_${index}`,
                item["id"],
                item["version"],
                item
              );
            }}
            className={"edit-options cursor-pointer actions-holder"}
            id={`actions_${index}`}
          >
            {" "}
            <span>Actions</span> <ChevronDown color={variables.primaryColor} />{" "}
          </FlexContainer>
        );
      default:
        return getPath(item, key, "NA");
    }
  };

  return (
    <AppReleasesListContainer>
      <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
      {showActionBar && (
        <ActionBarAppReleasesList
          handleBlur={handleBlur}
          permissions={permissions}
          top={actionCoord.top}
          right={actionCoord.right}
          appReleaseId={activeReleaseId}
          appReleaseVersion={appReleaseVersion}
          downloadAppApks={downloadAppApks}
          activeAppRelease={activeAppRelease}
          allMenuActions={allMenuActions}
        />
      )}
    </AppReleasesListContainer>
  );
};

const AppReleasesListContainer = styled.div`
  height: calc(100vh - 215px);
  .actions-holder {
    text-decoration: none;
  }
  .expand-collapse-text {
    color: ${variables.blue500};
    cursor: pointer;
  }
  .tableBodyRow {
    td {
      max-width: 350px;
    }
  }
`;

const mapStateToProps = (state) => {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    downloadAppApks: bindActionCreators(downloadAppApks, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppReleasesList);
